var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main__container"},[_c('div',{staticClass:"left-block"},[_c('p',[_vm._v("© "+_vm._s(_vm.currentYear)+" Nguyen Viet Trung")])]),_c('div',{staticClass:"right-block"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }